import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import TitleDataGrid from "../components/TitleDataGrid";
import TitleHeader from "../components/TitleHeader";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";
import { TitleConfigurationProps } from "../utils/types";

const TitleConfiguration = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}: TitleConfigurationProps) => {
  return (
    <>
      <TitleHeader
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
      <TitleDataGrid
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
      />
    </>
  );
};

// Map column options to match the expected format in HOC
const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

// Export the component wrapped with the HOC
const TransformedTitleConfiguration = PaginationAndColumnVisibilityHoc(
  TitleConfiguration,
  {
    columnOptions: transformedColumnOptions,
    defaultHiddenColumns: DefaultHiddenColumns,
    storageKey: "titleVisibleColumns",
  }
);

export default TransformedTitleConfiguration;
